import "./stylesMotorista.css";
import React from "react";
import { FaUserAlt, FaIdCard, FaTruck, FaCoins, FaClock } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import ProgressBar from '../ProgressBar';
import { format, toZonedTime } from 'date-fns-tz';
import { addHours } from 'date-fns';

const ListaMotorista = ({ listaMotoriista, maxHeight }) => {
  const navigate = useNavigate();

  const handleCardClick = (id) => {
    navigate(`/Motorista/${id}`);
  };

  const formatarDataHora = (datahora) => {
    const timeZone = 'America/Sao_Paulo';

    //// Converte a data para o fuso horário
    const dataZoned = toZonedTime(datahora, timeZone);

    //// somar 0 horas
    const dataSomada = addHours(dataZoned, 0);

    const formato = 'dd/MM/yyyy HH:mm:ss';
    return format(dataSomada, formato);
  };

  const formatNumber = (value) => {
    if (value === null || value === undefined) return '';

    if (value === 0) return '0,00';

    // Converte o valor para string apenas se necessário
    const stringValue = typeof value === 'string' ? value : value.toString();

    // Substitui vírgulas por pontos para permitir a conversão
    const numericValue = parseFloat(stringValue.replace(',', '.'));

    if (isNaN(numericValue)) return '';

    // Formata o número no estilo desejado
    return new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(numericValue);
  };

  return (
    <div className="card-container"
      style={{
        maxHeight: maxHeight || '65vh',
        overflowY: 'auto'
      }}
    >
      {listaMotoriista.map((motorista) => (
        <div
          key={motorista.IDusuario}
          className="card"
          onClick={() => handleCardClick(motorista.IDusuario)}
        >
          <div className="card-content">
            <div className="card-row" style={{ width: "100%" }}>
              <div className="card-info" align="left" style={{ fontSize: '0.8em', paddingLeft: '5%' }}>
                <h3 style={{ width: '100%', textAlign: 'start', marginBottom: '10px' }}>
                  <FaUserAlt style={{ marginRight: '8px' }} />
                  {motorista.nome + " (ID. " + motorista.IDusuario + ")"}
                </h3>
                <>
                  <FaIdCard style={{ marginRight: '8px', marginLeft: '15px' }} />
                  ID. Carga: <b>{motorista.IDlote}</b>
                </>
                <>
                  <FaClock style={{ marginRight: '8px', marginLeft: '15px' }} />
                  Placa: <b>{motorista.placa}</b>
                </>
                <>
                  <FaTruck style={{ marginRight: '8px', marginLeft: '15px' }} />
                  Saida: <b>{formatarDataHora(motorista.datahora)}</b>
                </>
                <>
                  <FaCoins style={{ marginRight: '8px', marginLeft: '15px' }} />
                  Vr.Carga:  <b>R$ {formatNumber(motorista.ValorEntregas)}</b>
                </>
                <br />
                <>
                  <FaCoins style={{ marginRight: '8px', marginLeft: '15px' }} />
                  Vr.Entregue:  <b>R$ {formatNumber(motorista.valorJaEntregue)}</b>
                </>

                <>
                  <FaCoins style={{ marginRight: '8px', marginLeft: '15px' }} />
                  Vr.Restante:  <b>R$ {formatNumber(motorista.ValorEntregas - motorista.valorJaEntregue)}</b>
                </>

              </div>

              <div className="card-progress" style={{ paddingLeft: "3%", paddingRight: "5%" }}>
                <div style={{ marginBottom: "10px" }}>
                  <ProgressBar
                    max={motorista.Nentregas}
                    value={motorista.NentregasRealizadas}
                    texto={"Andamento das visitas : "}
                  />
                </div>
                <ProgressBar
                  max={Math.round(motorista.VolumeTotal)}
                  value={Math.round(motorista.VolumeEntregue)}
                  texto={"Volume : "}
                />
              </div>

            </div>

          </div>
        </div>
      ))}
    </div>
  );
};

export default ListaMotorista;
